// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YeeN","footer":"styles_footer__3pNOa"};